var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#fff;}\n      .cls-2,.cls-3{fill:none;}\n      .cls-2{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}\n      .cls-3{opacity:0.2;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.43,65.37V43H22.87v66.52H63.13C63.13,85.73,60.16,65.37,38.43,65.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.43,43H76.25v22.4c18,0,23.15,14,24.37,32.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.43,
    y1: 65.37,
    x2: 76.25,
    y2: 65.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.01,
    y: 48.41,
    width: 24.79,
    height: 10.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.87,18.51c0,15.25,8.24,9.21,8.24,24.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.9,18.51c0,15.25,8.23,9.21,8.23,24.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "22.87 18.7 25.97 20.7 29.08 18.7 32.18 20.7 35.28 18.7 38.39 20.7 41.5 18.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.78,
    y: 97.75,
    width: 30.04,
    height: 11.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.93,
    cy: 85.72,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 80.78,
    cy: 85.72,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 90.63,
    cy: 85.72,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 65.73,
    cy: 76.53,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.58,
    cy: 76.53,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 85.43,
    cy: 76.53,
    r: 2.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.96,
    y1: 25.57,
    x2: 36.13,
    y2: 25.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.25,
    y1: 29.92,
    x2: 38.41,
    y2: 29.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.68,
    y1: 34.27,
    x2: 41.84,
    y2: 34.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.96,
    y1: 38.62,
    x2: 44.12,
    y2: 38.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.13,
    y1: 48.53,
    x2: 52.63,
    y2: 59.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.5,
    y1: 48.53,
    x2: 46.01,
    y2: 59.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.78,
    y1: 103.17,
    x2: 63.13,
    y2: 103.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.13 109.49 81.22 109.49 84.06 109.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 91.92,
    y1: 103.62,
    x2: 99.67,
    y2: 103.62
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128003);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_003.cbcfb98acdfa612c22795f7635daec02.svg";
export { ForwardRef as ReactComponent };